import { core, type Json } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 设置系统剪贴板的内容。调用成功后，会弹出 toast 提示"内容已复制"，持续 1.5s
 */
export const setClipboardData = (data: Json) => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<'fabric_utils.setClipboardData', string, boolean>(
      'fabric_utils.setClipboardData',
      JSON.stringify(data),
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};

/**
 * 获取系统剪贴板的内容, 注意剪贴板获取的内容可能是任意的, 并不一定是`setClipboardData`设置的内容, 所有JSON.parse要做兼容处理
 */
export const getClipboardData = <R extends Json>() => {
  return new Promise<R>((resolve, reject) => {
    core.call<'fabric_utils.getClipboardData', string>(
      'fabric_utils.getClipboardData',
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          try {
            resolve(JSON.parse(result.data));
          } catch {
            resolve(result.data as R);
          }
        }
      }
    );
  });
};
